import React, { useState, useEffect } from 'react';
import API_BASE from '../config';
import { FiTrash2, FiMail, FiPhone, FiCalendar, FiUser, FiInfo } from 'react-icons/fi';

export default function MessagesList() {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchMessages = () => {
        fetch(`${API_BASE}/admin/messages.php`)
            .then(r => r.json())
            .then(data => {
                if (data.status === 'success') {
                    setMessages(data.messages || []);
                }
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchMessages();
    }, []);

    const handleDelete = (id) => {
        if (!window.confirm('Are you sure you want to delete this inquiry?')) return;

        fetch(`${API_BASE}/admin/messages.php?id=${id}`, { method: 'DELETE' })
            .then(r => r.json())
            .then(data => {
                if (data.status === 'success') {
                    setMessages(messages.filter(m => m.id !== id));
                }
            });
    };

    if (loading) return <div className="p-12 text-center text-slate-400">Loading inquiries...</div>;

    return (
        <div className="space-y-6 animate-in fade-in duration-500">
            <div className="bg-white rounded-2xl border shadow-sm overflow-hidden">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-slate-50 border-b">
                            <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-widest">Customer</th>
                            <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-widest">Inquiry Details</th>
                            <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-widest">Received At</th>
                            <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-widest">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y text-sm">
                        {messages.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="px-6 py-12 text-center text-slate-400">No inquiries yet.</td>
                            </tr>
                        ) : (
                            messages.map((m) => (
                                <tr key={m.id} className="hover:bg-slate-50 transition-colors group">
                                    <td className="px-6 py-6">
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 bg-emerald-50 text-emerald-600 rounded-full flex items-center justify-center font-bold text-lg border border-emerald-100 shrink-0">
                                                {m.name[0]}
                                            </div>
                                            <div>
                                                <div className="font-bold text-slate-900">{m.name}</div>
                                                <div className="flex items-center gap-1 text-slate-500 text-xs mt-1">
                                                    <FiMail size={12} /> {m.email || 'N/A'}
                                                </div>
                                                <div className="flex items-center gap-1 text-slate-500 text-xs">
                                                    <FiPhone size={12} /> {m.phone}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-6 max-w-md">
                                        <div className="bg-slate-100/50 p-3 rounded-xl border border-slate-200/50">
                                            <p className="text-slate-700 whitespace-pre-wrap leading-relaxed line-clamp-3 italic">
                                                "{m.message}"
                                            </p>
                                        </div>
                                    </td>
                                    <td className="px-6 py-6">
                                        <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1.5 text-slate-600 font-medium">
                                                <FiCalendar size={14} className="text-[#2E63E8]" />
                                                {new Date(m.created_at).toLocaleDateString()}
                                            </div>
                                            <div className="text-xs text-slate-400 pl-5">
                                                {new Date(m.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-6">
                                        <button
                                            onClick={() => handleDelete(m.id)}
                                            className="p-3 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-xl transition-all"
                                            title="Delete Entry"
                                        >
                                            <FiTrash2 size={18} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
